import styled from 'styled-components';
import { Modal } from 'antd';
import { Paragraph } from '@/components/Typography';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		border-radius: 30px;
		min-width: 400px;
		max-width: 520px;
	}
`;

export const CustomConfirmMessage = styled(Paragraph)`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: -0.5%;
	text-align: center;
`;
